import { render, staticRenderFns } from "./NavigationLinkText.vue?vue&type=template&id=9a6ab3b2"
import script from "./NavigationLinkText.vue?vue&type=script&lang=ts"
export * from "./NavigationLinkText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports